module.exports = __webpack_public_path__ + "img/19292098.68b90497.jpg";